import withConfigTransport from '../../../../services/config-transport/withConfigTransport'
import _VaSelectContent from './VaSelectContent.vue'

export const VaSelectContent = withConfigTransport(_VaSelectContent)
